import { ROUTE_NAMES } from '@/lib/enums';

export const routes = [
    {
        path: 'fetch-response-profiles',
        meta: {
            requireAuth: true,
            breadcrumb: 'Fetch Response Profiles'
        },
        children: [    
            {
                path: '',
                name: ROUTE_NAMES.DEPOT.FETCH_RESPONSE_PROFILES.OVERVIEW,
                component: () => {return import('@/views/depot/fetch-response-profiles/Overview.vue')},
                meta: {
                    requireAuth: true,
                    breadcrumb: ''
                }
            },
            {
                path: 'profiles',
                component: () => {return import('@/views/depot/fetch-response-profiles/All-Profiles.vue')},
                name: ROUTE_NAMES.DEPOT.FETCH_RESPONSE_PROFILES.ALL_PROFILES,
                meta: {
                    requireAuth: true,
                    breadcrumb: 'Profiles'
                }
            },
            {
                path: 'profiles/:profile_uuid',
                component: () => {return import('@/views/depot/fetch-response-profiles/View-Profile.vue')},
                name: ROUTE_NAMES.DEPOT.FETCH_RESPONSE_PROFILES.VIEW_PROFILE,
                meta: {
                    requireAuth: true,
                    breadcrumb: 'Profile'
                }
            }
        ]
    }
];
